module.exports = __webpack_public_path__ + "img/head_two.65017034.png";